const userStatus = {
  Pending: 1,
  Active: 2,
  Disabled: 3
}

export default userStatus;